import { Component, Input, } from '@angular/core';
import { EventItemComponent } from '../../events-carousel/event-item/event-item.component';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';

declare var moment: any;
declare var ics: any;

@Component({
  selector: 'app-close-event-item',
  templateUrl: './close-event-item.component.html',
  styleUrls: ['./close-event-item.component.scss']
})
export class CloseEventItemComponent extends EventItemComponent {
  @Input({ required: true }) addToDiaryBtnText!: string;

  addToCalendarClick(type: CalendarItemEnum) {
    switch (type) {
      case CalendarItemEnum.Gmail:
        this.addGoogleCalendarEvent();
        break;
      case CalendarItemEnum.Outlook:
        this.addOutlookCalendarEvent();
        break;
      case CalendarItemEnum.Desktop:
        this.downloadDesktopCalendarEvent();
        break;
      default:
        break;
    }
  }

  private addGoogleCalendarEvent() {
    let startDate = moment(this.event.date).utc().format('YYYYMMDDTHHmmss');
    let endDate = moment(this.event.endDate).utc().format('YYYYMMDDTHHmmss');
    let link = [
      'https://www.google.com/calendar/render',
      '?action=TEMPLATE',
      '&text=' + encodeURIComponent(this.event.title!),
      '&dates=' + startDate + '/' + endDate
    ];

    if(this.event.description) {
      link.push('&details=' + encodeURIComponent(this.event.description));
    }
    if(this.event.location) {
      link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private addOutlookCalendarEvent() {
    let startDate = moment(this.event.date).utc().format('YYYY-MM-DDTHH:mm:ss');
    let endDate = moment(this.event.endDate).utc().format('YYYY-MM-DDTHH:mm:ss');

    let link = [
      'https://outlook.live.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=add',
      '&startdt=' + encodeURIComponent(startDate),
      '&enddt=' + encodeURIComponent(endDate),
      '&subject=' + encodeURIComponent(this.event.title!)
    ];

    if (this.event.description) {
        link.push('&body=' + encodeURIComponent(this.event.description));
    }

    if (this.event.location) {
        link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private downloadDesktopCalendarEvent() {
    let startDate = moment(this.event.date).utc().format('YYYY-MM-DDTHH:mm:ss');
    let endDate = moment(this.event.endDate).utc().format('YYYY-MM-DDTHH:mm:ss');
    var cal = ics();
    cal.addEvent(this.event.title, this.event.description, this.event.location, startDate, endDate);
    cal.download();
  }
}
